import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorSnackBar } from '../task-list/task-complete-complete';
import { Component} from '@angular/core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'did-not-complete-dialog',
    templateUrl: './did-not-complete-dialog.html',
    styleUrls: ['./task-list.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatInput, CdkTextareaAutosize, FormsModule, MatDialogActions, MatButton]
})
  export class DidNotCompleteDialog {
    deleteFlag: boolean;
    comment: string;
    
  
    constructor(
        public dialogRef: MatDialogRef<DidNotCompleteDialog>,
        private _snackBar: MatSnackBar) {
        this.deleteFlag = false;
        this.comment = '';
    }

    submitDidNotComplete(){
      if (this.comment == '' || this.comment == null){
        this._snackBar.openFromComponent(ErrorSnackBar, {
          duration: 5000,
        });
        this.deleteFlag = false

      } else {
        this.deleteFlag = true
        this.dialogRef.close({deleteFlag: this.deleteFlag, comment: this.comment});
      }
         
    }
  
    onNoClick(): void {
      this.dialogRef.close({deleteFlag: this.deleteFlag});
    }
  }
  
  
  export interface DialogData {
    deleteFlag: number;
    comment: string;
  }
